import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetCitiesMedicalGuide,
	GetCitiesMedicalGuideModel,
	GetCitiesMedicalGuideParams,
} from 'domain/usecases';

export class RemoteGetCitiesMedicalGuide implements GetCitiesMedicalGuide {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetCitiesMedicalGuideModel>,
	) {}

	async get({
		signal,
		...params
	}: GetCitiesMedicalGuideParams): Promise<GetCitiesMedicalGuideModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
